module.exports = __webpack_public_path__ + "img/txt.98ff4e47.svg";